import { addTaskConstant } from 'src/redux/actions/constant';

const {
  GET_TASK_AVAILABILITY_SUCCESS,
  GET_TASK_AVAILABILITY_FAILURE,
  GET_TASK_AVAILABILITY_LOADING,
  GET_TASK_AVAILABILITY_RESET,
} = addTaskConstant;

const initialState: object = {
  response: null,
  loading: false,
  isError: false,
};

export const taskAvailabilityReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case GET_TASK_AVAILABILITY_SUCCESS:
      return {
        ...state,
        response: action.payload,
        loading: false,
        isError: false,
      };
    case GET_TASK_AVAILABILITY_FAILURE:
      return {
        ...state,
        response: null,
        loading: false,
        isError: true,
        error: action.payload,
      };
    case GET_TASK_AVAILABILITY_LOADING:
      return {
        ...state,
        loading: true,
      };
    case GET_TASK_AVAILABILITY_RESET:
      return initialState;
    default:
      return state;
  }
};
